import rig from '../../assets/rig2.png'
import chart1 from '../../assets/chart1.png'

export default function TabPrototype() {

  return (
  <div className='align_left'>
    <section>
      <h2 className='align_center'>      
        Experimental Validation of the V-Drive Propulsion System
      </h2>
    </section> 
 
    <p>
      A laboratory prototype was developed to evaluate the operational characteristics of the V-Drive propulsion system 
      under controlled conditions and to investigate whether a fully self-contained, energy-driven device can generate 
      measurable directional force. 
    </p>
 
    <p>
        The experimental platform consisted of an airtight EPS enclosure (580 × 380 × 330 mm) suspended from a 1.9 m rigid frame 
        using four ropes. The enclosure was positioned approximately 50 mm above the floor, allowing unrestricted 
        horizontal motion while remaining mechanically isolated from external structures.      
    </p>

    <section className="align_center">
      <figure>
        <img src={rig} alt='' /> 
      </figure>
      <figcaption>Experimental rig setup</figcaption>
    </section>

    <p>
      The V-Drive propulsion unit was installed inside the sealed enclosure and operated as a completely autonomous system, 
      with no external electrical or mechanical connections. Wireless radio communication was used for command and control. 
      Force measurements were obtained using two precision 500 g straight-bar load cells mounted against the front 
      and rear walls of the enclosure. Sensor data were continuously acquired and recorded using an ESP32-S3 microcontroller.
    </p>

    <p>
      During operation, the propulsion unit generated a sequence of short-duration force pulses, 
      producing consistent directional motion of the suspended prototype. In the idle state, 
      both load cells exhibited stable baselines with minimal noise, confirming the reliability and repeatability of the measurement system. 
      Calibration tests using externally applied loads produced the expected proportional sensor responses, 
      further validating the instrumentation.      
    </p>

    <p>
      The most significant observation occurred during propulsion tests. The front load cell consistently detected 
      repeatable force pulses synchronised with the operation of the propulsion unit. 
      In contrast, the rear load cell did not record a corresponding force of equal magnitude in the opposite direction. 
      This asymmetric force distribution has been reproduced across multiple test runs and is the focus of our ongoing investigation.      
    </p>
        
    <section className="align_center">
      <img src={chart1} alt='' />   
      <br />
      Fig. 5. The propulsion unit pushes the prototype toward the sensor labelled "cell 4" 
    </section>

    <p>
      While these experimental results do not by themselves establish a new propulsion mechanism, 
      they represent repeatable observations that warrant further investigation using higher-resolution instrumentation, 
      improved environmental isolation, vacuum testing, and independent verification.
    </p> 
    
    <p>         
      Alongside the experimental programme, we have developed a mathematical model that, in our view, explains the observed behaviour 
      while remaining fully consistent with Newton's Third Law of Motion and the conservation of momentum. 
      The theoretical framework provides testable predictions that will be evaluated through future experiments and independent review.
    </p> 

    <p>            
      We welcome collaboration with researchers, universities, aerospace organisations, and independent laboratories 
      interested in validating the experimental results, reviewing the theoretical model, 
      and advancing the next stage of V-Drive development.      
    </p> 

  </div>   
  )
}
